import { createPinia } from 'pinia';
import { ViteSSG } from 'vite-ssg';

import 'vue-toastification/dist/index.css';
import '@assets/css/globals.scss';
// Imported from the module directly, not the ./init barrel, which also re-exports the
// PrimeVue setup and would pull @primevue/themes into this bundle.
import { applyToast } from './init/imports';
import { landingRoutes, registerRouterTracking, scrollBehavior } from './router/router';

import AppLanding from './AppLanding.vue';
import VueGtag from 'vue-gtag';

/**
 * Marketing site entry (index.html).
 *
 * Kept deliberately small: no PrimeVue, no i18n, no luxon, no animate.css, no primeicons and
 * no shared-components — the landing pages use none of them, and the business site's copies
 * live in main-business.ts. ViteSSG prerenders these routes to static HTML at build time.
 */
export const createApp = ViteSSG(
  AppLanding,
  { routes: landingRoutes, scrollBehavior },
  ({ app, router, isClient }) => {
    app.use(createPinia());

    if (isClient) {
      // vue-toastification mounts its container straight into document.body, so it can
      // only be installed in the browser.
      applyToast(app);
      registerRouterTracking(router);
      app.use(VueGtag, {
        includes: [
          { id: 'AW-16622960794' },
        ],
        config: { id: 'G-XGRX6YNVQE' }
      })
    }
  }
);
